<template>
	<section @click="setGAnalytics(oldPanelLink(`vendas/negocios/${data.id}`))" class="deal-card" :title="data.customer_name">
		<div class="status">
			<div class="stage" :title="data.stage">
				{{ data.stage }}
			</div>
			<div class="code">
				{{ data.id }}
			</div>
		</div>
		<div class="infos">
			<div class="client-infos">
				<div class="name"><em class="fal fa-user-circle"></em> {{ data.customer_name }}</div>
				<div class="interest">
					<a href="#">{{ data.product_name || '-' }}</a>
				</div>
			</div>
			<div class="contacts">
				<div class="phone">
					<em class="fal fa-mobile-android"></em><div class="phone-number">{{ customerPhoneComputed }}</div>
				</div>
				<div  class="email" :title="data.customer_email">
					<em class="fal fa-envelope"></em><div class="email-link">{{ data.customer_email ? data.customer_email : 'Não informado' }}</div>
				</div>
			</div>
			<div class="inactivity"><em class="fal fa-clock"></em>Inativo por {{ inactivity }} dias</div>
		</div>
	</section>
</template>


<script>
	import { helpersMixin, maskIntl } from '@/mixins'

	const moment = require('moment')
    require('moment/locale/pt-br')

	export default {
		props: {
			data: {
				type: Object,
				default() {
					return {}
				},
				required: true
			}
		},

		mixins: [helpersMixin, maskIntl],

		computed: {
			/**
			 * Computed property que calcula a quantidade de dias em que o negócio está
			 * inativo
			 */
			inactivity() {
				let days = 0

				if (this.data.updated_at) {
					const today = moment()
					const updatedAt = moment(this.data.updated_at)
					days = today.diff(updatedAt, 'days')
				}

				return days
			},
			/**
			 * Computed property que retorna o número de telefone ou celular com uma máscara
			 */
			customerPhoneComputed() {
                if (this.data.customer_mobile || this.data.customer_phone)
                    return this.data.customer_mobile ? this.formatPhoneNew(this.data.customer_country_code_mobile, this.data.customer_mobile) : this.formatPhoneNew(this.data.customer_country_code_phone, this.data.customer_phone)
                    
                return 'Não informado'
            },
		},
		methods: {
			setGAnalytics(url) {
				window.open(url, '_blank')
				this.$gtm.trackEvent({
                    event: "fac_button_click",
                    category: 'open-search',
                    action: "click",
                    label: 'Clique tag resultado pesquisa ',
                })
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>